import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

import {
  collection,
  query,
  where,
  getDocs
} from "firebase/firestore";

import { db } from "./firebase"; 
import "./demo.css";
import SEO from "./components/SEO";
import MarketingNavbar from "./components/MarketingNavbar";
import MarketingFooter from "./components/MarketingFooter";

export default function Demo() {
  const navigate = useNavigate();
const isReactSnap =
  typeof navigator !== "undefined" &&
  navigator.userAgent === "ReactSnap";
  const [loading, setLoading] = useState(false);

  const [showDemoUsedPopup, setShowDemoUsedPopup] = useState(false);
const [genericError, setGenericError] = useState("");

  const [templates, setTemplates] = useState([]);
const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [form, setForm] = useState({
    nome: "",
    telefono: "",
    email: "",
    password: "",
    nomeLocale: "",
  });



useEffect(() => {
  if (isReactSnap) return;
  const loadTemplates = async () => {

    try {

      const q = query(
        collection(db, "locali"),
        where("isDemoTemplate", "==", true)
      );

      const snap = await getDocs(q);

      const data = snap.docs.map(doc => ({
        id: doc.id,
        ...doc.data(),
      }));

      setTemplates(data);

      if (data.length > 0) {
        setSelectedTemplate(data[0]);
      }

    } catch (err) {

      console.error("Errore caricamento template:", err);

    }

  };

  loadTemplates();

}, []);

const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  try {

    setLoading(true);

    const functions = getFunctions(undefined, "europe-west1");

    const createDemoAccount = httpsCallable(
      functions,
      "createDemoAccount"
    );


    const result = await createDemoAccount({
      nome: form.nome,
      telefono: form.telefono,
      email: form.email,
      password: form.password,
      nomeLocale: form.nomeLocale,
      templateLocaleTag:
        selectedTemplate?.localeTag || selectedTemplate?.id,
    });

    console.log("DEMO CREATA:", result.data);

    // LOGIN AUTOMATICO

    const auth = getAuth();

    await signInWithEmailAndPassword(
      auth,
      form.email,
      form.password
    );

    // REDIRECT DASHBOARD

    navigate("/dashboard-gestore");

  } catch (err) {

    console.error("ERRORE DEMO:", err);


   if (
  err?.message?.toLowerCase().includes("già utilizzato") ||
  err?.message?.toLowerCase().includes("already")
) {

      setShowDemoUsedPopup(true);

    } else {

      setGenericError(
        err?.message ||
        "Errore durante la creazione della demo"
      );

    }

  } finally {

    setLoading(false);

  }
};

  return (
    <div className="demo-page">
<SEO
  title="Prova Gratis QrMenu per 7 Giorni | Demo Menu Digitale"
  description="Prova gratis QrMenu per 7 giorni: menu digitale, ordini dal tavolo facoltativi, cucina, sala, asporto con OTP e intelligenza artificiale. Nessuna carta di credito richiesta."
  canonical="https://qrmenu-italia.it/demo"
  image="https://qrmenu-italia.it/og-home-v2.jpg"
  keywords="prova gratis qrmenu, demo qrmenu, demo menu digitale, prova menu qr, menu digitale ristorante demo, menu digitale pizzeria demo"
/>
      <div className="demo-glow" />

      <MarketingNavbar />

      <main className="demo-main">
        <section className="demo-copy">
          <div className="demo-badge">Prova gratuita 7 giorni</div>

<h1>
  Prova QrMenu gratis per 7 giorni.
  <span> Configura il tuo locale e scopri cosa attivare.</span>
</h1>

<p>
  Crea una demo reale di QrMenu: menu digitale, ordini dal tavolo,
  gestione cucina, supporto alla sala, asporto con OTP e intelligenza
  artificiale. Dopo 7 giorni la prova si disattiva automaticamente.
</p>

<div className="demo-cards">
  <div className="demo-card">
    <strong>Menu già pronto</strong>
    <span>Parti da un esempio modificabile e adattalo al tuo locale.</span>
  </div>

  <div className="demo-card">
    <strong>Funzioni attivabili</strong>
    <span>Prova menu, ordini, cucina, sala, asporto e intelligenza artificiale.</span>
  </div>

  <div className="demo-card">
    <strong>Senza carta di credito</strong>
    <span>7 giorni di prova, senza impegno iniziale.</span>
  </div>
</div>
        </section>

        <section className="demo-panel">
          <h2>Crea la tua demo</h2>
  <p className="demo-panel-sub">
  Inserisci i dati e crea subito la tua prova gratuita.
</p>

          <form className="demo-form" onSubmit={handleSubmit}>
           <div className="demo-template-grid">

  {templates.map(template => (

    <button
      key={template.id}
      type="button"
      className={`demo-template-card ${
        selectedTemplate?.id === template.id ? "active" : ""
      }`}
      onClick={() => setSelectedTemplate(template)}
    >

      <strong>
        {template.nome || template.tipoDemo || "Demo"}
      </strong>

      <span>
        {template.tipoDemo || "Template demo"}
      </span>

    </button>

  ))}

</div>
            <input
              name="nomeLocale"
              value={form.nomeLocale}
              onChange={handleChange}
              placeholder="Nome locale"
              required
            />

            <input
              name="nome"
              value={form.nome}
              onChange={handleChange}
              placeholder="Nome e cognome"
              required
            />

            <input
              name="telefono"
              value={form.telefono}
              onChange={handleChange}
              placeholder="Cellulare"
              required
            />

            <input
              name="email"
              type="email"
              value={form.email}
              onChange={handleChange}
              placeholder="Email"
              required
            />

            <input
  name="password"
  type="password"
  value={form.password}
  onChange={handleChange}
  placeholder="Password"
  required
  minLength={6}
/>

<label
  style={{
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
    fontSize: "13px",
    lineHeight: "1.5",
    textAlign: "left",
  }}
>
  <input
    type="checkbox"
    required
    style={{
      marginTop: "3px",
      width: "16px",
      height: "16px",
      flexShrink: 0,
    }}
  />

  <span>
    Ho letto e preso visione della{" "}
    <a
      href="/privacy-policy"
      target="_blank"
      rel="noopener noreferrer"
      style={{ color: "inherit", textDecoration: "underline" }}
    >
      Privacy Policy
    </a>
    .
  </span>
</label>

<button type="submit" disabled={loading}>
              {loading ? "Creazione demo..." : "Crea la mia demo"}
              <span>→</span>
            </button>

            <small>
              Nessuna carta di credito richiesta. Demo valida 7 giorni.
            </small>
          </form>
        </section>
      </main>
      {showDemoUsedPopup && (
        <div className="demo-popup-overlay">

          <div className="demo-popup">

            <div className="demo-popup-icon">
              🎭
            </div>

            <h2>Demo già utilizzata</h2>

            <p>
              Hai già attivato una prova gratuita con questa email.
              <br /><br />
              Contattaci per riattivarla oppure passa alla versione completa.
            </p>

            <div className="demo-popup-actions">

              <button
                className="demo-popup-primary"
                onClick={() => navigate("/contatti")}
              >
                Contattaci
              </button>

              <button
                className="demo-popup-secondary"
                onClick={() =>
                  setShowDemoUsedPopup(false)
                }
              >
                Chiudi
              </button>

            </div>

          </div>

        </div>
      )}

      {genericError && (
        <div className="demo-error-box">
          {genericError}
        </div>
      )}
      <MarketingFooter />
    </div>
  );
}